import ChevronLeftIcon from '@cartwhl/ui/icons/ChevronLeftIcon';
import Button from '@cartwhl/ui/input/Button';

export interface ProfileMobileSubpageHeaderProps {
  title: string;
  className?: string;
  onBack: () => void;
}

export default function ProfileMobileSubpageHeader({
  title,
  className,
  onBack,
}: ProfileMobileSubpageHeaderProps) {
  return (
    <div className={className}>
      <Button
        type="button"
        variant="tertiary"
        icon={<ChevronLeftIcon />}
        onClick={onBack}
        className="-ml-3"
      >
        {title}
      </Button>
    </div>
  );
}
